module.exports = __webpack_public_path__ + "img/tw.7239a7f.svg";